import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { CdsLangService } from '@cds/ng-core/lang';
import { DOCUMENT } from '@angular/common';

import { LangEnum } from './constants/lang.enum';

// CDS uses the legacy `kh` code internally and in its translation files,
// but the BCP 47 standard requires `km` on the <html lang> attribute so
// screen readers and search engines recognise Khmer correctly.
const CDS_LANG_TO_BCP47: Record<string, string> = {
  kh: 'km',
  en: 'en',
};

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly langService = inject(CdsLangService);
  private readonly document = inject(DOCUMENT);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.route.queryParams
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => {
        const lang =
          params['lang'] === LangEnum.KH || params['lang'] === LangEnum.EN
            ? params['lang']
            : LangEnum.DEFAULT_LANG;
        this.langService.setCurrentLang(lang);
        this.document.documentElement.lang = CDS_LANG_TO_BCP47[lang] ?? lang;
      });
  }
}
